import React, { useContext, useEffect } from 'react';
import SimplePageTemplate from '../../Layout/SimplePageTemplate/SimplePageTemplate';
import {
  ContentBody,
  ContentTitle,
  ContentTitleContainer,
} from '../../Layout/SimplePageTemplate/SimplePageTemplate.styled';
import { AppContext, useAppContext } from '~/shared/hooks/AppContext';
import cookieUtils from '../../../lib/cookieUtils';
interface Props {
  type?: 'inactivity';
}
import { hideLoadingSpinner } from '../../../lib/spinnerUtils';

export const TYPES = {
  INACTIVITY: 'inactivity',
};

const LogoutLandingPage = ({ type }: Props) => {
  const { isMobileApp } = useAppContext();

  useEffect(() => {
    hideLoadingSpinner();
    sessionStorage.clear();

    const targetType = import.meta.env.REACT_APP_PROXY_TARGET_TYPE;
    if (targetType === 'JSON_SERVER') {
      cookieUtils.createMockCsrfCookies();
    }
  }, []);

  const handleContinue = () => {
    location.href = '/mortgages/';
  };

  return (
    <SimplePageTemplate
      title={type === TYPES.INACTIVITY ? 'Timed out' : 'MyMortgage'}
      onContinue={handleContinue}
      btnLabel={'Log in to MyMortgage'}
      btnId={'logout-continue-btn'}
      isMobileApp={isMobileApp}
    >
      <ContentTitleContainer>
        <ContentTitle>We&apos;ve logged you out of MyMortgage.</ContentTitle>

        {isMobileApp && (
          <ContentBody>
            You need to close this window &#40;tap X or &apos;Done&apos;&#41;
            and reopen your session. You might have to log in again.
          </ContentBody>
        )}
      </ContentTitleContainer>
    </SimplePageTemplate>
  );
};

// Props validated via TypeScript `Props` interface above

export default LogoutLandingPage;
